export const flowchartVersionsQueryKey = (cycleId, processId) => [
  'flowchart-versions',
  cycleId,
  processId
];

export const flowchartQueryKeys = {
  versions: {
    list: flowchartVersionsQueryKey
  }
};
